import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import { colors } from '../../../utils/Colors';
import './AboutUs.css';
import image1 from "../../../assets/slider/2nd.png"

const AboutUs = ({onGalleryPress}) => {
     const handleViewGallery = () => {
        if (onGalleryPress) {
            onGalleryPress();
        }
    };
    
    return (
        <div className="about-us-section py-5" style={{ backgroundColor: '#f9f9f9' }}>
            <Container>
               
                <div className="text-center mb-5">
                    <h1 className="display-4 fw-bold mb-3" style={{ color: colors.PRIMARY }}>
                        About RONAQ Banquet Islamabad
                    </h1>
                    <p className="lead text-muted">
                        Where Elegance Meets Excellence
                    </p>
                    <div className="divider mx-auto" style={{ 
                        width: '80px', 
                        height: '3px', 
                        backgroundColor: colors.SECONDARY,
                        marginTop: '20px'
                    }}></div>
                </div>

               
                <Row className="align-items-center mb-5">
                    <Col lg={6} className="mb-4 mb-lg-0">
                        <div className="about-image-wrapper position-relative">
                            <div 
                                className="about-main-image"
                                style={{
                                    backgroundImage: `url(${image1})`, // Yahan apna image laga diya
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    height: '400px',
                                    borderRadius: '15px',
                                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                                }}
                            ></div>
                            <div 
                                className="about-experience"
                                style={{
                                    position: 'absolute',
                                    bottom: '-20px',
                                    right: '20px',
                                    backgroundColor: colors.SECONDARY,
                                    color: 'white',
                                    padding: '20px',
                                    borderRadius: '10px',
                                    textAlign: 'center',
                                    boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
                                }}
                            >
                                <h3 className="fw-bold mb-0">10+</h3>
                                <p className="mb-0">Years Experience</p>
                            </div>
                        </div>
                    </Col>
                    
                    <Col lg={6}>
                        <h2 className="mb-4" style={{ color: colors.PRIMARY }}>
                            Welcome to RONAQ Banquet
                        </h2>
                        <p className="mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                            Located in the heart of Islamabad, <strong>RONAQ Banquet</strong> stands as a premier venue for 
                            celebrations, corporate events, and social gatherings. With our state-of-the-art facilities 
                            and exceptional service, we transform your special moments into unforgettable memories.
                        </p>
                        
                        <p className="mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                            Our mission is to provide a perfect blend of luxury, comfort, and elegance, ensuring 
                            every event hosted at RONAQ Banquet exceeds expectations. From intimate gatherings 
                            to grand celebrations, we cater to all your needs with professionalism and dedication.
                        </p>
                        
                        <div className="features-grid mb-4">
                            <Row>
                                <Col md={6}>
                                    <div className="d-flex align-items-center mb-3">
                                        <FaCheckCircle className="me-3" style={{ color: colors.SECONDARY, fontSize: '1.2rem' }} />
                                        <span>Luxurious Halls</span>
                                    </div>
                                    <div className="d-flex align-items-center mb-3">
                                        <FaCheckCircle className="me-3" style={{ color: colors.SECONDARY, fontSize: '1.2rem' }} />
                                        <span>Professional Catering</span>
                                    </div>
                                    <div className="d-flex align-items-center mb-3">
                                        <FaCheckCircle className="me-3" style={{ color: colors.SECONDARY, fontSize: '1.2rem' }} />
                                        <span>Modern Sound System</span>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="d-flex align-items-center mb-3">
                                        <FaCheckCircle className="me-3" style={{ color: colors.SECONDARY, fontSize: '1.2rem' }} />
                                        <span>Ample Parking</span>
                                    </div>
                                    <div className="d-flex align-items-center mb-3">
                                        <FaCheckCircle className="me-3" style={{ color: colors.SECONDARY, fontSize: '1.2rem' }} />
                                        <span>Experienced Staff</span>
                                    </div>
                                    <div className="d-flex align-items-center mb-3">
                                        <FaCheckCircle className="me-3" style={{ color: colors.SECONDARY, fontSize: '1.2rem' }} />
                                        <span>24/7 Security</span>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        
                        <Button 
                            variant="warning" 
                            size="lg"
                            className="px-4 py-2"
                            style={{ fontWeight: 'bold' }}
                            onClick={handleViewGallery} 
                        >
                            View Our Gallery
                        </Button>
                    </Col>
                </Row>

            </Container>
        </div>
    );
};

export default AboutUs;